module.exports = __webpack_public_path__ + "static/media/Picture5.a4878745.png";